export const managerPrices = {
  page: {
    title: "Preços da plataforma",
    subtitle: "Lista de preços dos planos da plataforma",
  },
  table: {
    name: "Nome",
    type: "Tipo",
    price: "Preço",
    created: "Criado em",
    edit: "Editar preço",
  },
  form: {
    title: "Atualizar preço",
    planName: "Nome do plano",
    planType: "Tipo de plano",
    annual: "Anual",
    monthly: "Mensal",
    cancel: "Cancelar",
    save: "Salvar",
  },
  toast: {
    saved: "Salvo com sucesso",
    error: "Erro na solicitação",
  },
};
